'use client'

import { useDeferredValue, useState } from 'react'
import { Search } from 'lucide-react'

import { InputGroup, InputGroupAddon, InputGroupInput } from '@ui/web/components'

import { LeaderboardRankings } from './list'
import { LeaderboardMetrics } from './metrics'

interface LeaderboardListProps {
  ids: {
    courseId?: string
    challengeId?: string
    learnEnrollmentId?: string
  }
}

export function LeaderboardList({ ids }: LeaderboardListProps) {
  const [searchInput, setSearchInput] = useState('')
  const deferredSearch = useDeferredValue(searchInput)

  return (
    <section className='srd:w-full srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-8 srd:text-neutral-white'>
      <div className='srd:flex srd:items-center srd:justify-between srd:gap-4 srd:w-full srd:flex-wrap srd:gap-y-3'>
        <LeaderboardMetrics ids={ids} />
        <InputGroup className='srd:shrink-0 srd:w-48 srd:rounded-full srd:bg-transparent srd:border-grey-40 srd:h-9'>
          <InputGroupAddon>
            <Search className='srd:text-grey-40' />
          </InputGroupAddon>
          <InputGroupInput
            placeholder='Cari'
            aria-label='Cari peserta'
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            className='srd:text-neutral-white srd:placeholder:text-grey-40'
          />
        </InputGroup>
      </div>
      <LeaderboardRankings ids={ids} deferredSearch={deferredSearch} />
    </section>
  )
}
